import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

interface IProps {
  isShowAvailableShifts: boolean;
  toggleShowAvailableShifts: () => void;
}

const useShowAvailableShifts = (): IProps => {
  const history = useHistory();
  const location = useLocation();

  const isShowAvailableShifts = useMemo((): boolean => {
    const query = new URLSearchParams(location.search);
    const queryParam = query.get('showAvailable');

    return queryParam?.toLocaleLowerCase() === 'true';
  }, [location]);

  const toggleShowAvailableShifts = useCallback(() => {
    const params = new URLSearchParams(history.location.search);
    params.set('showAvailable', String(!isShowAvailableShifts));
    history.push({ search: params.toString() });
  }, [history, isShowAvailableShifts]);

  return { isShowAvailableShifts, toggleShowAvailableShifts };
};

export { useShowAvailableShifts };
